export enum VerificationTaskPriority {
  Low = 0,
  Normal = 1,
  High = 2,
  Urgent = 3,
}
